module.exports = __webpack_public_path__ + "static/media/cover-real-size.516871bb.jpg";